import sessionStore from 'client/Session/SessionStore';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

/**
 * The single launch gate for teacher dashboard v2: flag on, resolved, and the
 * actor is a teacher. `hasTeacherDashboardV2` stays false while the flag loads
 * so callers render legacy without a flash. Non-teachers skip the query so an
 * anonymous `false` never gets cached for the session.
 */
export const useHasTeacherDashboardV2 = ({skip = false}: {skip?: boolean} = {}) => {
  const isTeacher = sessionStore.isTeacher();
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('teacher_dashboard_v2', {
    skip: skip || !isTeacher
  });

  return {
    hasTeacherDashboardV2: isFeatureEnabled && !isLoading && isTeacher,
    isLoading
  };
};
